module.exports = __webpack_public_path__ + "static/media/darker_lobby.0dfbd1b8.png";